import React, { useState } from 'react';
import DailyRecon from './DailyRecon';
import AdhaarPay from './AdhaarPay';
import MatmRecon from './MatmRecon';
import './AdhaarPay.css'


export default function MainRecon() {
    const [activeTab, setActiveTab] = useState('dailyrecon');

    const renderComponent = () => {
        switch (activeTab) {
            case 'dailyrecon':
                return <div className="tab-content">{<DailyRecon/>} </div>;
            case 'adhaarpay':
                return <div className="tab-content">{<AdhaarPay/>} </div>;
            case 'matmreport':
                return <div className="tab-content">{<MatmRecon/>} </div>;
            default:
                return <div className="tab-content"><DailyRecon /></div>;
        }
    };

  return (
      <div className="tabs-container">
         
          <div className="tabs-header">
              <button
                  className={`tab-btn ${activeTab === 'dailyrecon' ? 'active' : ''}`}
                  onClick={() => setActiveTab('dailyrecon')}
              >
                  AEPS Withdrawal
              </button>
              <button
                  className={`tab-btn ${activeTab === 'adhaarpay' ? 'active' : ''}`}
                  onClick={() => setActiveTab('adhaarpay')}
              >
                  AEPS Recon
              </button>
              <button
                  className={`tab-btn ${activeTab === 'matmreport' ? 'active' : ''}`}
                  onClick={() => setActiveTab('matmreport')}
              >
                  Matm Recon
              </button>
          </div>

       
          <div className="tab-viewport">
              {renderComponent()}
          </div>
      </div>
  )
}